import React from "react";
import PropTypes from "prop-types";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * Renders scope/context information only when relevant data is present.
 *
 * TODO: All fields below are not yet in the approval request API response.
 * Once the backend exposes budget_scope, related_system, and related_project
 * on the approval request detail, wire them through here.
 */
const ScopeContextPanel = ({ budgetScope, relatedSystem, relatedProject }) => {
  const hasData = budgetScope || relatedSystem || relatedProject;
  if (!hasData) return null;

  return (
    <div className="bg-card border border-card-bd rounded-card p-5">
      <div className="flex items-center gap-2 mb-4">
        <FontAwesomeIcon
          icon={icon({ name: "layer-group", family: "sharp", style: "light" })}
          className="text-text-2 text-sm"
        />
        <h3 className="text-sm font-semibold text-text">
          Scope &amp; Context
        </h3>
      </div>

      <div className="space-y-2 text-sm">
        {budgetScope && (
          <div className="flex justify-between">
            <span className="text-text-2">Budget scope</span>
            <span className="text-text font-medium">{budgetScope}</span>
          </div>
        )}
        {relatedSystem && (
          <div className="flex justify-between">
            <span className="text-text-2">Related system</span>
            <span className="text-text font-medium">{relatedSystem}</span>
          </div>
        )}
        {relatedProject && (
          <div className="flex justify-between">
            <span className="text-text-2">Related project</span>
            <span className="text-text font-medium">
              {relatedProject}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

ScopeContextPanel.propTypes = {
  budgetScope: PropTypes.string,
  relatedSystem: PropTypes.string,
  relatedProject: PropTypes.string,
};

export default ScopeContextPanel;
